// @ts-ignore
import createClickStream from '@uchi/client-clickstream';
import merge from 'lodash/merge';
import getConfig from 'next/config';
import { useContext } from 'react';
import { getCookie } from 'utils/cookie/getCookie';
import { appAuthContext } from 'context/AuthContext';

const {
  publicRuntimeConfig: { CLICKSTREAM_HOST },
} = getConfig();

interface ClickStreamEventProps {
  eventSource?: string;
  eventType?: string;
  eventInfo: string;
  eventInfoType?: string;
  guestUuid?: string;
  customDimentions?: {
    cd1?: string;
    cd2?: string;
    cd3?: string;
  };
}

class Clickstream {
  private static instance: Clickstream;
  private constructor() {
    if (typeof window !== 'undefined' && CLICKSTREAM_HOST) {
      return createClickStream({
        host: CLICKSTREAM_HOST,
        options: { version: 11 },
      });
    }
  }

  public static getInstance(): Clickstream {
    if (!Clickstream.instance) {
      Clickstream.instance = new Clickstream();
    }

    return Clickstream.instance;
  }
}

const useClickStreamEvent = () => {
  const clickstream: any = Clickstream.getInstance();
  const { user } = useContext(appAuthContext);

  const sendEvent = async <DataT extends ClickStreamEventProps>(data: DataT) => {
    if (!clickstream) return;

    const defaultData: ClickStreamEventProps = {
      eventInfo: '',
      eventSource: 'uchi_otvety',
      eventType: 'click',
      guestUuid: getCookie('GuestUUID') || '',
      customDimentions: {
        cd1: getCookie('GuestID') || '',
      },
    };
    data = merge(defaultData, data);

    const eventProps = {
      userId: user?.data?.attributes?.foreign_id || 0,
      userType: user?.data?.attributes?.type || 'guest',
      ...data,
    };

    return await clickstream.pageEvent(eventProps, { sendBeacon: true });
  };

  return { sendEvent };
};

export default useClickStreamEvent;
